import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w flex ai_center w-1200 mgx-auto h-80" }
const _hoisted_2 = { class: "inflex ai_center w-220 h-80" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  id: "",
  class: "inflex ai_center mgl-auto"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("案例")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("价格")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("渠道合作")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("关于我们")
const _hoisted_10 = { class: "inflex ai_center mgl-100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  class: "text-666 text-18 cur",
  href: "/admin"
}, "登录", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "w h",
          src: _ctx.state.imgUrl + '/index/logo.png'
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", {
          class: _normalizeClass(["header-nav cur inflex ai_center", [_ctx.currentRoutePath === '/'?'text-primary':'text-666']]),
          "data-url": "/"
        }, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "h-60 pdx-30 inflex ai_center jc_center text-18",
            "data-url": "/"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["header-nav cur inflex ai_center", [_ctx.currentRoutePath === '/case'?'text-primary':'text-666']]),
          "data-url": "/case"
        }, [
          _createVNode(_component_router_link, {
            to: "/case",
            class: "h-60 pdx-30 inflex ai_center jc_center text-18",
            "data-url": "/case"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["header-nav cur inflex ai_center", [_ctx.currentRoutePath === '/price'?'text-primary':'text-666']]),
          "data-url": "/price"
        }, [
          _createVNode(_component_router_link, {
            to: "/price",
            class: "h-60 pdx-30 inflex ai_center jc_center text-18",
            "data-url": "/price"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["header-nav cur inflex ai_center", [_ctx.currentRoutePath === '/cooperation'?'text-primary':'text-666']]),
          "data-url": "/cooperation"
        }, [
          _createVNode(_component_router_link, {
            to: "/cooperation",
            class: "h-60 pdx-30 inflex ai_center jc_center text-18",
            "data-url": "/cooperation"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["header-nav cur inflex ai_center", [_ctx.currentRoutePath === '/about'?'text-primary':'text-666']]),
          "data-url": "/about"
        }, [
          _createVNode(_component_router_link, {
            to: "/about",
            class: "h-60 pdx-30 inflex ai_center jc_center text-18",
            "data-url": "/about"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", {
          class: "cur w-100 h-40 inflex ai_center jc_center w-100 h-40 bg-btn cur text-white radius-50 mgl-30 btn-free",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mutationsPopupExperience && _ctx.mutationsPopupExperience(...args)))
        }, "免费试用")
      ])
    ])
  ]))
}